import {
  Star, Heart, Phone, Mail, MapPin, Clock,
  Home, Bell, Search, ShoppingCart, User, Globe,
  Truck, Tag, Gift, Shield, Award,
  Zap, Flame, Check, ChevronRight, ArrowRight,
  MessageCircle, Smile, Headphones, Camera, Bookmark, Sparkles,
  Settings, Layers, Code, Palette,
} from 'lucide-react';

export const ICON_OPTIONS = {
  Star, Heart, Phone, Mail, MapPin, Clock,
  Home, Bell, Search, ShoppingCart, User, Globe,
  Truck, Tag, Gift, Shield, Award,
  Zap, Flame, Check, ChevronRight, ArrowRight,
  MessageCircle, Smile, Headphones, Camera, Bookmark, Sparkles,
  Settings, Layers, Code, Palette,
};
